module.exports = __webpack_public_path__ + "static/iso-9001-7caee6f079282c4d9b6fa0600ca7fc13.png";